import _ from 'lodash'
import type {ClientSpecMap} from '@wix/document-services-types'
import {constants} from './constants'

const {BUILDER_TYPES} = constants

export const getLargestApplicationId = (clientSpecMap: ClientSpecMap): number =>
    _(clientSpecMap)
        .keys()
        .map(k => parseInt(k, 10))
        .compact()
        .concat(0)
        .max()!

export const generateApplicationId = (currentLargest: number, random: () => number = Math.random): number => {
    const randomNumber = (random() * 999 + 1 + random() * 99 + 1) | 0
    return _.max([currentLargest, 999])! + randomNumber
}

export const isBuilderComponent = (component: Record<string, any>) =>
    component?.type === BUILDER_TYPES.EDITOR_REACT_COMPONENT ||
    component?.type === BUILDER_TYPES.EDITOR_CONTEXT_PROVIDER ||
    component?.type === BUILDER_TYPES.EDITOR_FUNCTION_LIBRARY

export const mergeComponentsByReplacingBuilderComponents = (
    existingComponents: any,
    builderComponentsToReplaceWith: any
): any => {
    const nonBuilderComponents = (existingComponents ?? []).filter((component: any) => !isBuilderComponent(component))
    return [...(builderComponentsToReplaceWith ?? []), ...nonBuilderComponents]
}

export const mergeComponentsByReplacingNonBuilderComponents = (
    existingComponents: any,
    nonBuilderComponentsToReplaceWith: any
): any => {
    const existingBuilderComponents = (existingComponents ?? []).filter(isBuilderComponent)
    return [...existingBuilderComponents, ...(nonBuilderComponentsToReplaceWith ?? [])]
}

export const replaceCSMAndPreserveExistingBuilderComponents = (existingCSM: any, newCSM: any): any => {
    const mergedCSM = _.assign({}, existingCSM, newCSM)

    _.forEach(newCSM, (newAppData, applicationId) => {
        const existingAppData = existingCSM[applicationId]
        mergedCSM[applicationId] = {
            ...newAppData,
            components: mergeComponentsByReplacingNonBuilderComponents(
                existingAppData?.components,
                newAppData.components
            ),
            ...(existingAppData?.dependencies && {dependencies: existingAppData?.dependencies})
        }
    })

    return mergedCSM
}
